import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { NotImplementedComponent } from './not-implemented/not-implemented.component';
import { PagesRoutingModule } from './pages-routing.module';

@NgModule({
    declarations: [
        NotFoundComponent,
        NotImplementedComponent,
        AccessDeniedComponent,
    ],
    imports: [CommonModule, PagesRoutingModule],
})
export class PagesModule {}
